module.exports = __webpack_public_path__ + "img/2.e8ca26c1.jpg";